import * as _ from 'lodash'
import globalRelay from './globalRelay';
import { isToday, isTomorrow, isYesterday, format } from 'date-fns';
import modelSetFactory from './modelSet';

const valueFilters = {
	toUtcDate: function (val) {
		if (typeof val === 'string' && !/(Z|UTC|(\+|-)\d{2}:\d{2})$/.test(val)) {
			val += 'Z';
		}

		return valueFilters.toDate(val);
	},

	toDate: function (val) {
		if (!val || val instanceof Date) {
			return val;
		}

		return new Date(val);
	},

	toString: function (val) {
		return (typeof val === 'string') ? val : (typeof val === 'undefined') ? undefined : val.toString(); // eslint-disable-line no-nested-ternary
	},

	toNumber: function (val) {
		return (typeof val === 'undefined') ? val : _.toFinite(val);
	},

	toBoolean: function (val) {
		return !!val;
	},

	toModel: function (factory) {
		const filter = (val) => { return factory(val); };

		filter.factory = factory;

		return filter;
	},

	toModelSet: function (factory) {
		const filter = val => {
			if (!val) {
				return undefined;
			}
			else if (typeof val.toDocumentArray === 'function') {
				return val;
			}
			else if (_.isArray(val)) {
				return modelSetFactory(val, factory);
			}
			else {
				throw new Error('Invalid attempt to create Model Set.');
			}
		};
		filter.factory = factory;
		filter._isModelSet = true;

		return filter;
	},

	trim: function (val) {
		return (!!val && typeof val === 'string') ? val.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '') : val;
	},

	lowerCase: function (val) {
		return (!!val && typeof val === 'string') ? val.toLowerCase() : val;
	},

	upperCase: function (val) {
		return (!!val && typeof val === 'string') ? val.toUpperCase() : val;
	},

	clean: function (val) {
		if (typeof val !== 'undefined' && val === null) {
			return undefined;
		}

		return valueFilters.trim((!!val && typeof val === 'string') ? val.replace(/[\s\uFEFF\xA0]{2,}/g, ' ') : val);
	},

	cleanNumber: function (val) {
		if (val === null || val === '') {
			return undefined;
		}
		else if (typeof val !== 'number') {
			val = valueFilters.trim(val.toString());
			val = val.replace(/[^\d-\.]/g, '');
		}

		return val;
	},

	cleanInteger: function (val) {
		if (typeof val !== 'undefined' && val === null) {
			return undefined;
		}
		else if (typeof val !== 'number') {
			val = valueFilters.trim(val.toString());
			val = val.replace(/[^\d,]/g, '');
		}

		return val;
	},

	toShortTime: function (val) {
		if (val) {
			return format(val, 'hh:mm aa', { locale: globalRelay.dateLocale });
		}

		return '';
	},

	toShortDate: function (val) {
		if (val) {
			return format(val, 'MM/DD/yy', { locale: globalRelay.dateLocale });
		}

		return '';
	},

	toShortDateTime: function (val) {
		if (val) {
			return format(val, 'MM/DD/yy hh:mm aa', { locale: globalRelay.dateLocale });
		}

		return '';
	},

	isToday: function (val) {
		if (val) {
			return isToday(val);
		}

		return false;
	},

	isTomorrow: function (val) {
		if (val) {
			return isTomorrow(val);
		}

		return false;
	},

	isYesterday: function (val) {
		if (val) {
			return isYesterday(val);
		}

		return false;
	}
};

export default valueFilters;